var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoForHeroSection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 651,
    height: 417,
    viewBox: "0 0 651 417",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0000152588,
    y: 117,
    width: 173,
    height: 57,
    fill: "#00A44F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0000152588,
    y: 235,
    width: 173,
    height: 57,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M651 0V417H234V238.28H293.574V357.427H591.427V0H651Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M531 0V59.0143H293.403V177H234V0H531Z",
    fill: "#00A44F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M412.99 179V237.986H531V297H354V120H531V179H412.99Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoForHeroSection);
export default __webpack_public_path__ + "static/media/logoForHeroSection.f4642841fd4b8de5387cbe0f6302016f.svg";
export { ForwardRef as ReactComponent };